<h2 class="sectionTitle">{{'SHARED.REPORTS.SUPPLIER_REPORT_TITLE'| translate}}</h2>
<div class="services-filter">

  <div class="form-container" *ngIf="enabel">
    <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>

    <!--	Account status -->
    <div class="form-group">
      <label for="AccountStatusId">{{'SHARED.REPORTS.SUPPLIER_LISTING_ACCOUNT_STATUS' | translate}}</label>
      <select id="AccountStatusId" name="AccountStatusId" class="form-control" [(ngModel)]="AccountStatusId">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <ng-container *ngFor="let accountStatus of AccountStatus">
          <option *ngIf="displayedLang=='en'" [value]="accountStatus.Id">
            {{accountStatus.NameEN}}
          </option>
          <option *ngIf="displayedLang=='ar'" [value]="accountStatus.Id">
            {{accountStatus.NameAR}}
          </option>
        </ng-container>
      </select>
    </div>
    <!--	Supplier Types -->
    <div class="form-group">
      <label for="AccountStatusId">{{'SHARED.REPORTS.SUPPLIER_LISTING_SUPPLIER_Type' | translate}}</label>
      <select id="AccountStatusId" name="AccountStatusId" class="form-control" [(ngModel)]="SupplierTypeId">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <ng-container *ngFor="let supplierType of SupplierTypes">
          <option *ngIf="displayedLang=='en'" [value]="supplierType.Id">
            {{supplierType.NameEN}}
          </option>
          <option *ngIf="displayedLang=='ar'" [value]="supplierType.Id">
            {{supplierType.NameAR}}
          </option>
        </ng-container>
      </select>
    </div>

    <!--supplierNumber-->
    <div class="form-group">
      <label for="SupplierNumber">{{ 'SHARED.REPORTS.SUPPLIER_NUMBER' | translate }}</label>
      <input type="text" id="SupplierNumber" name="SupplierNumber" class="form-control" [(ngModel)]="SupplierNumber" />
    </div>
    <!--companyName-->
    <div class="form-group">
      <label for="CompanyName">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.BASIC_SUPPLIER_INFO_TAB.COMPANY_NAME' | translate }}</label>
      <input type="text" id="CompanyName" name="CompanyName" class="form-control" [(ngModel)]="CompanyName" />
    </div>
    <!--companyEmail-->
    <div class="form-group">
      <label for="CompanyEmail">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.CONTACT_PERSON_EMAIL' | translate }}</label>
      <input type="text" id="CompanyEmail" name="CompanyEmail" class="form-control" [(ngModel)]="CompanyEmail" />
    </div>
    <!--category-->
    <!-- <div class="form-group">
      <label for="category">{{'ADMIN_USER.E_TENDER_FORM.ETENDERS_CATEGORIES' | translate}}</label>
      <select id="category" name="category" class="form-control" [(ngModel)]="category">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <ng-container *ngFor="let supplierCategory of SupplierCategories">
          <option *ngIf="displayedLang=='en'" [value]="supplierCategory.Id">
            {{supplierCategory.NameEN}}
          </option>
          <option *ngIf="displayedLang=='ar'" [value]="supplierCategory.Id">
            {{supplierCategory.NameAR}}
          </option>
        </ng-container>
      </select>
    </div> -->
    <div class="form-group">
      <label for="category">{{'ADMIN_USER.E_TENDER_FORM.ETENDERS_CATEGORIES' | translate}}</label>
    <ng-multiselect-dropdown id="category"
    placeholder="{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}"
    [settings]="dropdownSettings"
    [data]="SupplierCategories"
    [(ngModel)]="selectedItems">
  </ng-multiselect-dropdown>
</div>

    <!--TaxCardNumber -- It's Card Number in UI but Record Number in Code -->
    <div class="form-group">
      <label for="TaxRecordNumber">{{ 'ADMIN_USER.SUPPLIER_EXCEL_OBJECT.TaxCardNumber' | translate }}</label>
      <input type="text" id="TaxRecordNumber" name="TaxRecordNumber" class="form-control" [(ngModel)]="TaxRecordNumber" />
    </div>
    <!--RequestNumber-->
    <div class="form-group">
      <label for="RequestNumber">{{ 'SHARED.MYTASKS.RequestNumber' | translate }}</label>
      <input type="text" id="RequestNumber" name="RequestNumber" class="form-control" [(ngModel)]="RequestNumber" />
    </div>
    <!--MobileNumber-->
    <div class="form-group">
      <label for="MobileNumber">{{ 'FRONT_USER.SUPPLIER_REGISTRATION_FORM.SHARED.PHONE' | translate }}</label>
      <input type="text" id="MobileNumber" name="MobileNumber" class="form-control" [(ngModel)]="MobileNumber" />
    </div>
  </div>
  <div class="btns-holder text-center" *ngIf="enabel">
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadData()"
      value="{{ 'SHARED.Search' | translate}}" />
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetData()"
      value="{{ 'SHARED.ResetSearch' | translate}}" />
    <input type="button" class="SCAcustomBtn" *ngIf="!hideExportButton" (click)="ExportExcel()"
      value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
  </div>
</div>
<app-grid-view #SupplierList [customMenuTemplate]="supplierTemplate" [HasMenu]="HasMenu" [IsHtml]="IsHtml">
</app-grid-view>


<ng-template #supplierTemplate let-item let-menuItems="menuItems">

  <li role="menuitem"
    *ngIf="isRate&&(item.AccountStatus != ('FRONT_USER.SUPPLIER_LISTING_REPORT.PENDING_ADMIN_APPROVAL'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="rateSupplier(item.RequestId)">
      {{ 'FRONT_USER.SUPPLIER_LISTING_REPORT.RATE' | translate }}
    </a>
  </li>
  <li role="menuitem" *ngIf="enabel&&(item.AccountStatus ==('FRONT_USER.SUPPLIER_LISTING_REPORT.ACTIVATED'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="disabledSupplier(item.RequestId)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.DISABLE' | translate }}
    </a>
  </li>

  <li role="menuitem"
    *ngIf="isPurchasingCategoryAdmins&&(item.AccountStatus == ('FRONT_USER.SUPPLIER_LISTING_REPORT.ACTIVATED'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="blackListSupplier(item.RequestId)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.BLACK_LIST' | translate }}
    </a>
  </li>

  <li role="menuitem" *ngIf="enabel&&(item.AccountStatus == ('FRONT_USER.SUPPLIER_LISTING_REPORT.DISABLED'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="enableSupplier(item.RequestId)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.ENABLE' | translate }}
    </a>
  </li>

  <li role="menuitem"
    *ngIf="isPurchasingCategoryAdmins&&(item.AccountStatus == ('FRONT_USER.SUPPLIER_LISTING_REPORT.DISABLED'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="blackListSupplier(item.RequestId)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.BLACK_LIST' | translate }}
    </a>
  </li>

  <li role="menuitem"
    *ngIf="enabel&&(item.AccountStatus == ('FRONT_USER.SUPPLIER_LISTING_REPORT.BLACL_LISTED'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="enableSupplier(item.RequestId)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.ENABLE' | translate }}
    </a>
  </li>

  <li role="menuitem"
    *ngIf="isPurchasingCategoryAdmins&&(item.AccountStatus == ('FRONT_USER.SUPPLIER_LISTING_REPORT.BLACL_LISTED'|translate))">
    <a class="dropdown-item" Confirmation (confirmationClick)="enableSupplier(item.RequestId)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.REMOVE_FROM_BLACK_LIST' | translate }}
    </a>
  </li>

  <!-- <li role="menuitem">
    <a class="dropdown-item" Confirmation (confirmationClick)="editSupplier(item)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.VIEW_DETAILS' | translate }}
    </a>
  </li> -->
  <li role="menuitem">
    <a class="dropdown-item"  (click)="editSupplier(item)">
      {{'FRONT_USER.SUPPLIER_LISTING_REPORT.VIEW_DETAILS' | translate }}
    </a>
  </li>
</ng-template>